import React from 'react'
import { Link } from 'gatsby'

import style from './Sidebar.module.scss'

const SidebarResource = ({ 
  resource,
  location
}) => (
  <Link
    className={style.link}
    activeClassName={style.activeAnchor}
    to={ resource.path }
    data-selected={resource.path === location.pathname}
  >
    <span className={style.verb}>
      data
    </span>
    <p>{ resource.title }</p>
  </Link>
)

export default SidebarResource